export default {
  computed: {
    currentObjectUrl: {
      get() {
        const active = this.currentObject;
        if (!active.meta || !active.meta.site_url) {
          return '';
        }
        return active.meta.site_url;
      },
      set(value) {
        this.addLink(value);
      },
    },
  },
  methods: {
    addLink(url) {
      const active = this.currentObject;
      if (active && active.get('type') !== 'image') {
        return;
      }
      if (!active.meta) {
        active.meta = {};
      }
      active.meta.site_url = url;
    },
  },
};
